import React from "react";
import DDOption from "./DDOption";

const Dropdown = function Dropdown(props) {

    if ( !props.data ) return (<div>NO DATA</div>)

    const options = props.data.map( (item, key) => {
        return(
            <DDOption key={key} {...props.formatter(item)} />
        )
    });

    return (
        <div>

        <div className="field">
            <label className="label">{props.label}</label>
            <div className="control">
            { props.data ?
                <div className="select is-medium">
                    <select onChange={props.onchange} value={props.value}>
                        { props.preOptions ?
                            props.preOptions.map( (item, key) =>{
                                return (
                                    <DDOption key={key} {...item} />
                                )
                            })
                            :'' }
                        {options}
                    </select>
                </div>
                : ' - NO DATA - '
            }
            </div>
        </div>
        </div>
    );
};

export default Dropdown;
